import React from 'react';
import { mapDispatchToProps, mapStateToProps } from '../Store';
import { Snackbar } from 'sg-ui-components';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

const SnackbarContainer = ({ notification, actions, config }) => {
    if (!config?.web?.features?.rewardsNotifications) {
        return null;
    }
    const history = useHistory();

    return (
        <div>
            <Snackbar
                items={(Array.isArray(notification?.data) ? notification.data : [])?.map((item) => ({
                    ...item,
                    id: item.id,
                    imageUrl: item?.content?.thumb || 'https://placehold.co/850',
                    imageAltText: item?.content?.subject,
                    title: item?.content?.subject || item.id,
                    description: item?.content?.body || item.notification_type,
                    // TODO: add the proper details link for non-promotion notifications
                    detailsLink:
                        item?.content?.promotion_id && new Date(item?.content?.promotion_quantum_end) >= Date.now()
                            ? `/promotion?promotion=${item?.content?.promotion_id}`
                            : null,
                }))}
                meta={notification?.meta || {}}
                show={true}
                onCloseAll={() => actions.notificationActions.dismissAllNotifications()}
                onCloseItem={async (notificationId) => {
                    await actions.notificationActions.dismissNotification(notificationId);
                    // Refetch notifications after dismissing one
                    actions.notificationActions.getNotifications();
                }}
                onMyActivity={() => history.push('/my-activity')}
            />
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarContainer);
